import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CircularProgress from 'apollo-react/components/CircularProgress';
import Divider from 'apollo-react/components/Divider';
import VerticalPrimeTable from '../../common/DataTable/verticalPrimeTable';
import LinkedItemsList from '../../common/LinkedItemsList/LinkedItemsList';
import styles from './FormDetails.module.css';

const FormDetails = ({ persona }) => {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const response = await axiosInstance.get(`/api/forms/${id}`);
        setForm(response.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchForm();
  }, [id]);

  if (!form) {
    return (
      <div className={styles.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  const metadata = {
    name: form.name,
    description: form.description,
    status: form.published === true ? t('published') : t('unpublished'),
    createdAt: form.createdAt,
    updatedAt: form.updatedAt,
    createdBy: form.User?.username,
  };

  return (
    <div className={styles.container}>
      <VerticalPrimeTable data={metadata} />

      <Divider />

      <LinkedItemsList
        items={form.subforms || []}
        titleKey="linked_subforms"
        emptyKey="no_linked_subforms"
        linkPrefix="subforms"
        persona={persona}
      />
    </div>
  );
};

export default FormDetails;
